import CryptoToken from "@/common/module/cryptoToken";

type IWebStorageKey =
  | "cas_token"
  | "access_token"
  | "refresh_token"
  | "id_token";

class WebStorage {
  setItem(key: IWebStorageKey, content: any) {
    const encrypted = CryptoToken.encodeToBase64(content);
    localStorage.setItem(key, encrypted);
  }

  getItem(key: IWebStorageKey) {
    const content = localStorage.getItem(key);
    return content ? CryptoToken.decodeFromBase64(content) : "";
  }

  removeItem(key: IWebStorageKey) {
    localStorage.removeItem(key);
  }

  clear() {
    localStorage.clear();
  }
}

export default new WebStorage();
